import { List, ListItem } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import PropTypes from "prop-types";
import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import { ProgressBar } from "react-step-progress-bar";
import "react-step-progress-bar/styles.css";
import { updateDayCard } from "../redux/actions/dataActions";


class DayCardCheckbox extends Component {
  updateDayCard = (programId, dayId, taskNumber, isDone) => {
    this.props.updateDayCard({classId: programId, dayId, taskNumber, isDone});
  };

  render() {
    // Check that redux state has the necessary fields to render this compoent
    if (this.props.data.syllabus === null) {
        return (
            <Fragment>
                Loading...
            </Fragment>
        )
    }
    const { tasks, status, dayId } = this.props.data.syllabus[this.props.day];
    
    return (
      <React.Fragment>
        <br />
        <ProgressBar
          percent={(status.reduce((x,y) => x+y) / status.length) * 100}
          filledBackground="linear-gradient(to right, #f3a634, #f3a634)"
        />

        <FormGroup aria-label="position" row>
          <List className="courses-college-regis">
            <ListItem>
              <div>
                {tasks.map((a, i) => (
                  <div key={i}>
                    <FormControlLabel
                      key={a}
                      name={a}
                      type="checkbox"
                      labelPlacement="end"
                      label={<small>{a}</small>}
                      control={
                        <Checkbox
                          key={i}
                          color="primary"
                          name="a"
                          checked={status[i]===1}
                          tasknumber={i}
                          onClick={()=>this.updateDayCard(this.props.data.programId, dayId, i, Math.abs(status[i]-1))}
                        />
                      }
                    />
                    <br />
                  </div>
                ))}
              </div>
            </ListItem>
          </List>
        </FormGroup>
      </React.Fragment>
    );    
  }
};


DayCardCheckbox.propTypes = {
  data: PropTypes.object.isRequired,
  updateDayCard: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  data: state.data
});

export default connect(
  mapStateToProps,
  { updateDayCard }
)(DayCardCheckbox);